module.exports = __webpack_public_path__ + "static/img/icon.3b4173e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_8/icon.jpg
// module id = JoYB
// module chunks = 0